//
//

import { mapGetters, mapActions, mapMutations } from "vuex";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import { uid } from "quasar";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import AQCheckbox from "@/components/Generics/AQCheckbox/AQCheckbox.vue";

export default {
    name: "ScFunctionsVariables",
    components: {
        AQButton,
        AQModal,
        AQInput,
        AQDialog,
        AQCard,
        AQDropdown,
        AQCheckbox
    },
    props: {
        functionUuid: { type: String, default: "" },
        data: { type: Array, default: () => [] },
        isReturn: Boolean,
        ddlType: { type: Array, default: () => [] },
        activeTab: { type: String, default: "" },
        contractDetails: { type: Object, default: () => {} }
    },
    data() {
        return {
            newValueModal: false,
            isEditValue: false,
            indexEdit: null,
            varType: "",
            name: "",
            idParam: null,
            isDisabledBtn: false,
            description: "",
            isArray: false,
            isIndexed: false,
            variableDDLType: [],
            arrayOption: [],
            hasHeaderActions: false,
            headerActions: [{
                label: this.$t("diagrams.components.setLevels.delete")
            }],
            isReadonly: false,
            noNameError: false,
            noTypeError: false,
            openDialog: false,
            titleDialog: "",
            messageTitle: "",
            action: "",
            ddlToReturn: [],
            mutableData: Object.assign([], this.data),
            objectTitle: [{
                label: this.$t("dataModel.name"),
                value: "dtmodel",
                disable: true,
                icon: "label_important"
            }],
            type: null,
            defaultValueType: ""
        };
    },
    computed: {
        ...mapGetters("smartContractDesigner", ["inEditFunction"]),
        ...mapGetters("diagrams", ["modelForProcessDefinition"]),
        ...mapGetters("apps", ["currentApp"]),
        ddlSelect() {
            return {
                options: this.changeDDL(this.ddlType),

                errorLabel: this.$t("errorRequired")
            };
        },
        getAddLabel() {
            return this.$t(
                `smartContract.${
                    this.isReturn ? "returnVars.addReturns" : "parameters.addParam"
                }`
            );
        },
        getTitle() {
            return this.$t(
                `smartContract.${
                    this.isReturn ? "returnVars.title" : "parameters.title"
                }`
            );
        },
        titleSubModal() {
            let title = null;
            if (this.isEditValue) {
                title = this.$t(`smartContract.${this.isReturn ? "returnVars.editParams" : "parameters.editParams"}`);
            } else {
                title = this.$t(`smartContract.${this.isReturn ? "returnVars.addReturns" : "parameters.addParam"}`);
            }
            return title;
        },

        create() {
            return this.isEditValue ? { label: this.$t("smartContract.editBtn"), disabled: this.isDisabledBtn }
                : { label: this.$t("smartContract.addBtn"), disabled: this.isDisabledBtn };
        }

    },
    created() {
        this.isReadonly = this.contractDetails && this.contractDetails.publishStatus === "IMPORTED";
    },

    methods: {
        ...mapMutations("smartContractDesigner", ["removeVariable"]),
        ...mapActions("smartContractDesigner", ["getNewVariableModel"]),

        okAction() {
            if (this.action === "deleteParam" && this.mutableData && this.mutableData.length) {
                for (let i = 0; i < this.mutableData.length; i++) {
                    if (this.mutableData[i].index === this.indexEdit) {
                        this.mutableData.splice(i, 1);
                        if (this.mutableData[i]) {
                            this.mutableData[i].index = i;
                        }
                        this.$emit("saveData", this.mutableData);
                        this.newValueModal = false;
                    }
                }
            } else if (this.action === "closeModalParam") {
                this.newValueModal = false;
            }
            this.openDialog = false;
        },
        cancelAction() {
            this.openDialog = false;
        },
        dataModel() {
            return this.modelForProcessDefinition({ withProps: { isBCReady: true } });
        },
        changeDDL() {
            this.ddlToReturn = [];
            Object.assign(this.ddlToReturn, this.ddlType);
            if (this.contractDetails.bcType.type === "BC_HLF") {
                const data = this.dataModel();
                if (data) {
                    data.forEach(element => {
                        this.ddlToReturn.push({
                            id: element.name, label: element.name, value: element.name, data: element
                        });
                    });
                }
            }
            return this.ddlToReturn;
        },
        addEditValue(value) {
            if ((this.contractDetails && this.contractDetails.publishStatus === "IMPORTED" && value)
            || (this.contractDetails && this.contractDetails.publishStatus !== "IMPORTED")) {
                this.arrayOption = [];
                this.indexEdit = value ? value.index : null;
                this.isEditValue = !!value;
                this.idParam = value ? value.id : null;
                this.name = value ? value.name : null;
                this.description = value ? value.description : null;
                this.varType = value ? value.bcDataTypeDto : null;
                this.isArray = value ? value.isArray : false;
                this.isIndexed = value && value.isIndexed ? value.isIndexed : false;
                if (this.contractDetails.publishStatus === "IMPORTED") {
                    this.hasHeaderActions = false;
                } else {
                    this.hasHeaderActions = !!value;
                }
                this.variableDDLType = this.ddlToReturn;
                this.isDisabledBtn = true;
                this.newValueModal = true;
                this.noNameError = false;
                if (this.varType) {
                    this.defaultValueType = this.varType.id || this.varType.type;
                }
            }
        },

        modalShow() {
            if (!this.isEditValue) {
                this.$refs.ddlType.clearValue();
            }
        },
        changeValue(newValue, fromName) {
            if (this.isEditValue) {
                this.isDisabledBtn = false;
                this.noNameError = !this.name;
            } else {
                this.noNameError = !this.name && fromName;
                if (newValue && this.varType) {
                    this.isDisabledBtn = false;
                }
            }
        },

        valueSelected(value) {
            if (value && value.length) {
                const filterRez = this.ddlToReturn.filter(el => el.value === value[0].value);
                this.varType = filterRez[0].data || "";
                this.noTypeError = !this.varType;
                this.defaultValueType = value[0].value || "";
                this.isDisabledBtn = !(value && this.name);
            }
        },
        createTypeObject(object) {
            return {
                active: null,
                canBeArray: null,
                id: null,
                modelDataType: object.name,
                name: null,
                type: object.name
            };
        },
        validateParamName() {
            const validatePattern = new RegExp("^[a-zA-Z]*[a-zA-Z_][a-zA-Z0-9_]*$");
            return validatePattern.test(this.name);
        },
        actionNewValue(action) {
            if (action === "primary") {
                if (this.name && this.validateParamName() && this.varType) {
                    const obj = {
                        id: this.isEditValue ? this.idParam : uid(),
                        functionId: this.functionUuid,
                        staticFunctionId: null,
                        name: this.name,
                        type: this.varType && this.varType.fields ? this.varType.name : "",
                        bcDataTypeDto: this.varType && this.varType.fields ? this.createTypeObject(this.varType) : this.varType,
                        index: this.isEditValue ? this.indexEdit : this.mutableData.length,
                        isArray: this.isArray,
                        isIndexed: this.isIndexed,
                        isInput: !this.isReturn,
                        description: this.description
                    };
                    if (this.isEditValue) {
                        for (let i = 0; i < this.mutableData.length; i++) {
                            if (this.mutableData[i].index === this.indexEdit) {
                                this.mutableData[i] = obj;
                                break;
                            }
                        }
                    } else {
                        this.mutableData.push(obj);
                    }
                    this.newValueModal = false;
                    this.$emit("saveData", this.mutableData);
                } else {
                    this.$toast.showNotify({
                        type: "error",
                        message: this.$t("smartContract.manageFunctions.noNameError")
                    });
                }
            } else if (action === "close") {
                if (!this.isDisabledBtn) {
                    this.titleDialog = this.$t("smartContract.confirmationDialog.title");
                    this.messageTitle = this.$t("smartContract.confirmationDialog.msg");
                    this.action = "closeModalParam";
                    this.openDialog = true;
                } else {
                    this.noNameError = false;
                    this.noTypeError = false;
                    this.newValueModal = false;
                }
            } else if (action.toLowerCase() === "delete") {
                this.titleDialog = this.$t("smartContract.removeTitle");
                this.messageTitle = this.$t("smartContract.dialogBodyDefault");
                this.action = "deleteParam";
                this.openDialog = true;
            }
        }
    }
};
